import commonUtils from "@/utils/common.utils";
import store from "../store/store";
import auth from "@/utils/auth.utils";

const authGuard = async (to, from, next) => {
  try {
    console.log("to", to.params);
    console.log("from", from.params);
    if (!store.getters['userData/accessToken']) throw ('no access token')
    if (!store.getters['userData/isLogin']) throw ('token expired')
    next();
  } catch (error) {
    commonUtils.createToast('warning', error)
    console.error("auth guard error", error);
    auth.logout();
    next({ path: `/${to.params.store}` });
  }
};

export default authGuard;
